<template>
  <li
    class="nav-item mt-1"
    :class="isExpanded ? ' justify-content-start' : 'd-flex flex-row justify-content-center'"
  >
    <div
      :class="[
        'nav-link ms-nav',
        { active: active, disabled: disabled },
        isExpanded ? 'justify-content-between' : 'justify-content-center ms-nav-sm'
      ]"
      class="d-flex flex-row rounded NKT-P1"
      :id="'nav-link-' + name"
    >
      <div>
        <img :src="icon" alt="" class="nav-icon" :class="{ expanded: isExpanded }" />
        <span :class="['ms-nav-text', { expanded: isExpanded }]">{{ isExpanded ? name : '' }}</span>
      </div>

      <div style="position: relative" v-if="disabled">
        <LockIndicator
          class="lock-indicator"
          v-if="!comingSoon"
          style="position: absolute"
        ></LockIndicator>
        <ComingIndicator
          :is-expanded="isExpanded"
          class="lock-indicator"
          style="position: absolute"
          v-else
        ></ComingIndicator>
      </div>
    </div>
  </li>
</template>

<script setup lang="ts">
import { computed, defineProps } from 'vue'
import { useRoute } from 'vue-router'
import alarmLog from '@/assets/svg/nav/alarm-log.svg'
import documentation from '@/assets/svg/nav/documentation.svg'

import electricalPerformance from '@/assets/svg/nav/electrical-performance.svg'
import electricalPerformanceDisabled from '@/assets/svg/nav/electrical-performance-disabled.svg'

import home from '@/assets/svg/nav/home.svg'

import marineSurvey from '@/assets/svg/nav/marine-survey.svg'
import marineSurveyDisabled from '@/assets/svg/nav/marine-survey-disabled.svg'

import mechPhys from '@/assets/svg/nav/mech-phys.svg'
import mechPhysDisabled from '@/assets/svg/nav/mech-phys-disabled.svg'

import spareParts from '@/assets/svg/nav/spare-parts.svg'
import sparePartsDisabled from '@/assets/svg/nav/spare-parts-disabled.svg'

import settings from '@/assets/svg/nav/settings.svg'
import LockIndicator from './LockIndicator.vue'
import ComingIndicator from './ComingIndicator.vue'

var props = defineProps({
  name: String,
  href: String,
  isExpanded: Boolean,
  disabled: Boolean,
  comingSoon: Boolean,
  hoverandActiveBg: {
    type: String,
    default: '#f5f5f5'
  }
})

const icon = computed(() => {
  switch (props.name) {
    case 'Alarm Log':
      return alarmLog
    case 'Electrical Performance':
      return props.disabled ? electricalPerformanceDisabled : electricalPerformance
    case 'Mechanical & Physical Data':
      return props.disabled ? mechPhysDisabled : mechPhys
    case 'Marine Survey Data':
      return props.disabled ? marineSurveyDisabled : marineSurvey
    case 'Spare Parts':
      return props.disabled ? sparePartsDisabled : spareParts
    case 'Documentation':
      return documentation
    case 'Home':
      return home
    case 'Administration':
      return settings
    default:
      return ''
  }
})

const route = useRoute()

const active = computed(() => {
  if (props.href === undefined || props.href === '/') {
    return route.path === '/'
  }

  var active = route.path.startsWith('/' + props.href)

  return active
})
</script>

<style scoped lang="scss">
@use '@/styles/ms-color-styles.scss' as color;

.lock-indicator {
  top: -14px;
  right: -20px;
}

.ms-nav-sm {
  width: 56px;
}

.ms-nav {
  height: 42px;
}

.ms-nav-text {
  opacity: 0;
  transition: opacity 0.1s ease 0.2s;
}

.ms-nav-text.expanded {
  opacity: 1;
}

.nav-icon {
  width: 20px;
  height: 20px;
  margin-right: 0px;
}

.nav-icon.expanded {
  margin-right: 20px;
}

.navbar-expand-md .navbar-nav .nav-link.active:before {
  border-left: none;
}

.router-link-active:not(.disabled-link) .nav-link {
  background-color: v-bind('hoverandActiveBg') !important;
  border-radius: 4px !important;
}

.navbar-nav .nav-item .nav-link:hover {
  background-color: v-bind('hoverandActiveBg') !important;
  border-radius: 4px !important;
}

.navbar-nav .nav-link.active,
.navbar-nav .nav-link.show,
.navbar-nav .nav-link:not(.active) {
  color: color.$color-nordic-blue-base;
}

.navbar-nav .nav-link.disabled {
  color: color.$color-dark-grey;
}
</style>
